import { createRoot } from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';

import App from './App';
import React from 'react';
import theme from './assets/styles/index.js';
import { AuthProvider } from './provider';
import ErrorProvider from './error-provider/ErrorProvider';
import { GoogleOAuthProvider } from '@react-oauth/google';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <AuthProvider>
        <ChakraProvider theme={theme}>
            <ErrorProvider>
                <GoogleOAuthProvider clientId='969254022592-kb1pirqsja4gic51fklr8a96irq0o1ji.apps.googleusercontent.com'>
                    <App />
                </GoogleOAuthProvider>
            </ErrorProvider>
        </ChakraProvider>
    </AuthProvider>
);
